'use client';
import { authService } from '@/app/api/service/auth';
import { setXPartnerfromQueryString } from "@/app/utils/helper";
import React, { createContext, useContext, useEffect, useState } from 'react';

interface AuthContextType {
  isAuthenticated: boolean;
  isLoading: boolean;
  isAuthFetched: boolean;
  autoLogin: () => Promise<void>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthFetched, setIsAuthFetched] = useState(false);

  const autoLogin = async () => {
    try {
      const authStatus = await authService.getAuthStatus();
      setIsAuthenticated(authStatus);
    } catch (error) {
       console.error(error)
      setIsAuthenticated(false);
    } finally {
      setIsLoading(false);
      setIsAuthFetched(true);
    }
  };

  useEffect(() => {
    setXPartnerfromQueryString();
    autoLogin();
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthFetched, isAuthenticated, isLoading, autoLogin }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}